import { useLocation } from "react-router-dom";

const ClaimInfo = () => {
    const location = useLocation();
    const { ClaimDetails } = location.state;
    console.log(ClaimDetails, "Claim Details");
    return (
            <div className="row">
                <h4>Intimated Claim</h4>
                <ul className="PolicyDetails">
                    <li>
                        Admission Date: <span>{ClaimDetails.AdmissionDate}</span>
                    </li>
                    <li>
                        Billed Amount: <span>{ClaimDetails.BilledAmount}</span>
                    </li>
                    <li>
                        Claim Amount: <span>{ClaimDetails.ClaimAmount}</span>
                    </li>
                    <li>
                        Claim Date: <span>{ClaimDetails.ClaimDate}</span>
                    </li>
                    <li>
                        Claim Description: <span>{ClaimDetails.ClaimDesc}</span>
                    </li>
                    <li>
                        Claim No: <span>{ClaimDetails.ClaimNo}</span>
                    </li>
                    <li>
                        Claim Status: <span>{ClaimDetails.ClaimStatus}</span>
                    </li>
                    <li>
                        Claim Type: <span>{ClaimDetails.ClaimType}</span>
                    </li>
                    <li>
                        Company Name: <span>{ClaimDetails.CompanyName}</span>
                    </li>
                    <li>
                        Customer Email ID: <span>{ClaimDetails.CustomerEmailId}</span>
                    </li>
                    <li>
                        Customer Mobile No: <span>{ClaimDetails.CustomerMobileNo}</span>
                    </li>
                    <li>
                        Customer Name: <span>{ClaimDetails.CustomerName}</span>
                    </li>
                    <li>
                        Discharge Date: <span>{ClaimDetails.DischargeDate}</span>
                    </li>
                    <li>
                        Policy No: <span>{ClaimDetails.PolicyNo}</span>
                    </li>
                    <li>
                        Policy SubType: <span>{ClaimDetails.PolicySubType}</span>
                    </li>
                    <li>
                        Policy Type: <span>{ClaimDetails.PolicyType}</span>
                    </li>
                    <li>
                        Product Type: <span>{ClaimDetails.ProductType}</span>
                    </li>

                </ul>
            </div>
    );
};

export default ClaimInfo;
